module.exports = __webpack_public_path__ + "static/media/next-icon-fork-o.867b0794.svg";